import Image from "next/image";
import React from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

function Hero({ Mydata }) {
  const data = Mydata[0];
  return (
    <div className="mx-auto max-w-7xl px-4 text-[#2B3252]">
      <span className="bg-[#E9EDFF] font-base font-normal px-2 py-1 rounded-md inline-block mb-2">
        {data?.subtitle}
      </span>
      <h1 className="text-3xl mt-2 font-bold mb-2">{data.mainTitle}</h1>
      <p className="font-base font-normal mb-2 ml-1">{data.date}</p>
      <Image src={data.image} width={1300} height={100} alt={data.mainTitle} />
      <h1 className="text-3xl mt-2 font-bold">{data?.secondHeading}</h1>
      <div
        className="updatedparapremu mt-2"
        dangerouslySetInnerHTML={{ __html: data.des0 }}
      ></div>
      <div
        className="updatedparapremu mt-2  "
        dangerouslySetInnerHTML={{ __html: data.des }}
      ></div>

      <h2 className="text-3xl mt-2 font-bold">{data.title}</h2>

      <div
        className="updatedparapremu mb-2 pt-2"
        dangerouslySetInnerHTML={{ __html: data.des2 }}
      ></div>
      <div
        className="updatedparapremu"
        dangerouslySetInnerHTML={{ __html: data.des1 }}
      ></div>
      <div>
        {data.benefits.map((benefit, index) => (
          <div key={index} style={{ marginBottom: "20px" }}>
            <h2 className="text-2xl mt-2 font-bold">{benefit.title}</h2>
            <div dangerouslySetInnerHTML={{ __html: benefit.des }}></div>
            {benefit.sections.map((section, idx) => (
              <div key={idx} style={{ marginLeft: "20px" }}>
                <h3 className="text-xl mt-2 font-semibold">
                  {section.subtitle}
                </h3>
                <div
                  dangerouslySetInnerHTML={{ __html: section.content }}
                ></div>
              </div>
            ))}
          </div>
        ))}

        {/* tags  */}
        <div className="tags-container mt-6 mb-7">
          <div className="flex justify-between">
            <div>
              {" "}
              <h2 className="text-2xl font-bold mb-2">Tags</h2>
            </div>
            <div className="flex gap-3 justify-center items-centrer">
              Share this post
              <span className="flex pt-1 gap-2">
                <FaFacebook />
                <FaInstagram />
                <FaXTwitter />
              </span>
            </div>
          </div>

          <div className="flex flex-wrap gap-4">
            {data?.tags?.map((tag, index) => (
              <span
                key={index}
                style={{ border: "1px solid #2B3252" }}
                className=" font-base font-normal px-2 py-1 rounded-2xl inline-block"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Hero;
